








































































































































































































































































































































































































































































































































































import Vue from 'vue';
import html2canvas from 'html2canvas';
import AirStatusResultBar from '@/components/result/AirStatusResultBar.vue';
import PlaneDetailResult from '@/components/result/PlaneDetailResult.vue';
import CalcManager from '@/classes/calcManager';
import EnemyFleet from '@/classes/enemy/enemyFleet';
import Fleet from '@/classes/fleet/fleet';
import AirCalcResult from '@/classes/airCalcResult';
import Item from '@/classes/item/item';
import Const, { AB_MODE, Formation, SUPPORT_TYPE } from '@/classes/const';
import CommonCalc from '@/classes/commonCalc';
import Airbase from '@/classes/airbase/airbase';
import Enemy from '@/classes/enemy/enemy';
import Ship from '@/classes/fleet/ship';
import Convert from '@/classes/convert';

export default Vue.extend({
  name: 'MainResult',
  components: {
    AirStatusResultBar,
    PlaneDetailResult,
  },
  props: {
    value: {
      type: CalcManager,
      required: true,
    },
    handleChangeMainBattle: {
      type: Function,
      required: true,
    },
    handleChangeFormation: {
      type: Function,
      required: true,
    },
    handleMoreCalculate: {
      type: Function,
      required: true,
    },
    handleMinimize: {
      type: Function,
      required: true,
    },
    calculateCount: {
      type: Number,
      default: 5000,
    },
  },
  data: () => ({
    tab: 'battle0',
    displayBattle: 0,
    destroyDialog: false,
    detailDialog: false,
    detailParent: undefined as Ship | Enemy | Airbase | undefined,
    detailIndex: 0,
    detailFleetIndex: 0,
    capturing: false,
    moreCalculateRequested: false,
    enabledTooltip: false,
    tooltipTimer: undefined as undefined | number,
    tooltipX: 0,
    tooltipY: 0,
    fuelCorr: '',
    ammoCorr: '',
  }),
  computed: {
    formations(): Formation[] {
      return Const.FORMATIONS;
    },
    airbaseWaveResults(): { text: string; result: AirCalcResult; baseIndex: number }[] {
      const waveResults: { text: string; result: AirCalcResult; baseIndex: number }[] = [];
      for (let i = 0; i < this.value.airbaseInfo.airbases.length; i += 1) {
        const airbase = this.value.airbaseInfo.airbases[i];

        if (airbase.mode !== AB_MODE.BATTLE) {
          continue;
        }

        if (airbase.battleTarget[0] === this.displayBattle) {
          waveResults.push({ text: `Land Base ${i + 1} 1st Wave`, result: airbase.resultWave1, baseIndex: i });
        }
        if (airbase.battleTarget[1] === this.displayBattle) {
          waveResults.push({ text: `Land Base ${i + 1} 2nd Wave`, result: airbase.resultWave2, baseIndex: i });
        }
      }

      return waveResults;
    },
    fleet(): Fleet {
      return this.value.fleetInfo.mainFleet;
    },
    airbases(): Airbase[] {
      return this.value.airbaseInfo.airbases;
    },
    enabledAirbase(): { airbase: Airbase; index: number }[] {
      const target = this.value.mainBattle;
      const airbases = [];
      for (let i = 0; i < this.value.airbaseInfo.airbases.length; i += 1) {
        const airbase = this.value.airbaseInfo.airbases[i];
        if (airbase.mode === AB_MODE.BATTLE && airbase.battleTarget.includes(target)) {
          airbases.push({ airbase, index: i });
        }
      }
      return airbases;
    },
    tableData(): { name: string; items: Item[]; index: number }[] {
      const fleet = this.value.fleetInfo.mainFleet;
      const ships = [];

      const activeShips = fleet.ships.filter((v) => v.isActive && !v.isEmpty);
      for (let i = 0; i < activeShips.length; i += 1) {
        const planes = activeShips[i].items.filter((v) => v.data.isPlane);
        if (planes.length) {
          ships.push({ name: activeShips[i].data.name, items: planes, index: i });
        }
      }
      return ships;
    },
    enemyTableData(): { enemy: Enemy; items: Item[]; allDeathRate: number; index: number }[] {
      const fleet = this.value.battleInfo.fleets[this.value.mainBattle];
      const enemies = [];

      for (let i = 0; i < fleet.enemies.length; i += 1) {
        const enemy = fleet.enemies[i];
        const planes = enemy.items.filter((v) => v.data.isPlane && !v.data.isRecon);
        if (planes.length) {
          let allDeathRate = 1;
          for (let j = 0; j < planes.length; j += 1) {
            const plane = planes[j];
            if (plane.data.isAttacker) {
              allDeathRate *= plane.deathRate / 100;
            }
            plane.deathRate = Math.round(plane.deathRate);
          }
          enemies.push({
            enemy,
            items: planes,
            allDeathRate: Math.floor(1000 * allDeathRate) / 10,
            index: i,
          });
        }
      }
      return enemies;
    },
    supportsTableRow(): { name: string }[] {
      const rows = [];
      const fleets = this.value.fleetInfo.fleets.filter((v, i) => i < 4);
      const mainIndex = this.value.fleetInfo.mainFleetIndex;
      for (let i = 0; i < fleets.length; i += 1) {
        // 出撃中のやつは出撃中フラグを建てる
        let isMainFleet = false;
        if (i === mainIndex || (this.value.fleetInfo.isUnion && mainIndex <= 1 && i <= 1)) {
          isMainFleet = true;
        }

        const fleet = fleets[i];
        const types = fleet.supportTypes;

        const needResult = types.includes(SUPPORT_TYPE.AIRSTRIKE) || types.includes(SUPPORT_TYPE.ANTI_SUBMARINE);
        const result = fleet.results.find((v) => v.supportRates.some((w) => w > 0));

        const rates = needResult && result ? result.supportRates.map((v) => Math.round(10 * v) / 10) : [0, 0, 0, 0, 0];
        const avg = needResult && result ? Math.round(result.loopSumEnemySupportAirPower) : 0;
        const enemyAirPower = avg ? `${avg}（ ${CommonCalc.getAirStatusBorder(avg).slice(0, 4).join(' / ')} ）` : '';
        rows.push({
          name: `Fleet ${i + 1}`,
          typeName: fleet.getSupportTypeName(),
          airPower: fleet.supportAirPower,
          enemyAirPower,
          rates: rates.slice(0, 5),
          isMainFleet,
        });
      }

      return rows;
    },
    battles(): EnemyFleet[] {
      return this.value.battleInfo.fleets;
    },
    battleCount(): number {
      return this.value.battleInfo.battleCount;
    },
    results(): AirCalcResult[] {
      return this.value.fleetInfo.mainFleet.results;
    },
    calcBauxite(): string {
      return (5 * this.value.fleetInfo.mainFleet.mainResult.avgDownSlot).toFixed();
    },
    calcSteel(): string {
      return this.value.fleetInfo.mainFleet.mainResult.avgUsedSteels.toFixed();
    },
    airPowerBorders: () => (airPower: number) => `${airPower}（ ${CommonCalc.getAirStatusBorder(airPower).slice(0, 4).join(' / ')} ）`,
    consumptions(): number[][] {
      return this.value.battleInfo.getResourceConsumptions(this.$store.state.maps);
    },
    remainingFuelAndAmmos(): { fuel: { value: number; color: string }; ammo: { value: number; color: string } }[] {
      // 残りの燃料弾薬を計算 表示用
      const values = [[100, 100]];
      const array = this.consumptions;
      for (let i = 0; i < array.length - 1; i += 1) {
        values.push([Math.max(values[i][0] - array[i][0], 0), Math.max(values[i][1] - array[i][1], 0)]);
      }

      const remainings = [];
      for (let i = 0; i < values.length; i += 1) {
        const fuel = values[i][0];
        const ammo = values[i][1];
        remainings.push({
          fuel: { value: fuel, color: this.getFuelTextColor(fuel) },
          ammo: { value: ammo, color: this.getAmmoTextColor(ammo) },
        });
      }
      return remainings;
    },
    sumFuelAndAmmo(): number[] {
      const ships = this.fleet.ships
        .filter((v) => v.isActive && !v.isEmpty)
        .map((v) => Object.assign(v, { consumptionFuel: 0, consumptionAmmo: 0, consumptionAmmo2: 0 }));
      const array = this.consumptions;
      for (let i = 0; i < array.length; i += 1) {
        const isLast = i === array.length - 1;
        // この戦闘で消費する燃料弾薬 %
        const fuelConsumptionRate = array[i][0] / 100;
        const ammoConsumptionRate = array[i][1] / 100;
        for (let j = 0; j < ships.length; j += 1) {
          const { fuel, ammo } = ships[j].data;
          // 消費記録
          if (fuelConsumptionRate) {
            ships[j].consumptionFuel += Math.max(Math.floor(fuel * fuelConsumptionRate), 1);
          }
          if (ammoConsumptionRate) {
            ships[j].consumptionAmmo += Math.max(Math.floor(ammo * ammoConsumptionRate), 1);
            if (isLast) {
              // todo 最終戦闘 夜戦した時の消費の仕様
              ships[j].consumptionAmmo2 += Math.max(Math.floor(ammo * ammoConsumptionRate), 1);
            } else {
              ships[j].consumptionAmmo2 += Math.max(Math.floor(ammo * ammoConsumptionRate), 1);
            }
          }
        }
      }

      let sumFuel = 0;
      let sumAmmo = 0;
      for (let j = 0; j < ships.length; j += 1) {
        const isMarriage = ships[j].level > 99;
        const { consumptionFuel, consumptionAmmo, data } = ships[j];
        // 消費記録
        if (consumptionFuel) {
          if (consumptionFuel < data.fuel) {
            sumFuel += Math.max(Math.floor(consumptionFuel * (isMarriage ? 0.85 : 1)), 1);
          } else {
            sumFuel += Math.max(Math.floor(data.fuel * (isMarriage ? 0.85 : 1)), 1);
          }
        }

        if (consumptionAmmo) {
          if (consumptionAmmo < data.ammo) {
            sumAmmo += Math.max(Math.floor(consumptionAmmo * (isMarriage ? 0.85 : 1)), 1);
          } else {
            sumAmmo += Math.max(Math.floor(data.ammo * (isMarriage ? 0.85 : 1)), 1);
          }
        }
      }
      return [sumFuel, sumAmmo];
    },
    existUnknownEnemy(): boolean {
      return this.value.battleInfo.fleets.some((v) => v.existUnknownEnemy);
    },
  },
  methods: {
    refresh() {
      this.handleChangeMainBattle(this.displayBattle);
    },
    changedTab(index: number) {
      if (this.displayBattle === index) {
        return;
      }

      if (index >= 0) {
        this.displayBattle = index;
      } else {
        this.displayBattle = this.battles.length - 1;
      }

      this.handleChangeMainBattle(this.displayBattle);
    },
    changedFormation(formation: number) {
      this.handleChangeFormation(formation);
    },
    calculateMore() {
      this.moreCalculateRequested = true;
      this.handleMoreCalculate();
    },
    clickedAirbaseRow(index: number) {
      this.viewDetail(this.airbases[index], index);
    },
    clickedShipRow(index: number) {
      const fleet = this.value.fleetInfo.mainFleet;
      const activeShips = fleet.ships.filter((v) => v.isActive && !v.isEmpty);
      const ship = activeShips[index];

      const shipIndex = fleet.ships.findIndex((v) => v === ship);
      if (shipIndex >= 0) {
        this.detailFleetIndex = this.value.fleetInfo.mainFleetIndex;
        this.viewDetail(ship, shipIndex);
      }
    },
    viewDetail(parent: Enemy | Ship | Airbase, index: number): void {
      this.detailParent = parent;
      this.detailIndex = index;
      if (parent instanceof Enemy) {
        this.detailFleetIndex = this.displayBattle;
      }
      this.destroyDialog = false;
      this.detailDialog = true;
    },
    closeDetail() {
      this.detailDialog = false;
      setTimeout(() => {
        this.detailParent = undefined;
      }, 100);
    },
    toggleDetailDialog() {
      if (!this.detailDialog) {
        this.closeDetail();
      } else {
        this.destroyDialog = false;
      }
    },
    captureResult() {
      // 背景色とかを塗るフラグ立て
      this.capturing = true;
      const div = document.getElementById('result-container') as HTMLDivElement;
      setTimeout(() => {
        html2canvas(div, { scale: 2 }).then((canvas) => {
          const link = document.createElement('a');
          link.href = canvas.toDataURL();
          link.download = `result_${Convert.formatDate(new Date(), 'yyyyMMdd-HHmmss')}.jpg`;
          link.click();
          this.capturing = false;
        });
      }, 10);
    },
    getFuelTextColor(value: number): string {
      if (value <= 10) {
        return 'fuel-warning4';
      }
      if (value <= 20) {
        return 'fuel-warning3';
      }
      if (value <= 30) {
        return 'fuel-warning2';
      }
      if (value <= 50) {
        return 'fuel-warning1';
      }
      if (value < 75) {
        return 'fuel-warning';
      }
      return 'fuel-normal';
    },
    getAmmoTextColor(value: number): string {
      if (value <= 15) {
        return 'fuel-warning4';
      }
      if (value <= 25) {
        return 'fuel-warning3';
      }
      if (value <= 35) {
        return 'fuel-warning2';
      }
      if (value <= 40) {
        return 'fuel-warning1';
      }
      if (value < 50) {
        return 'fuel-warning';
      }
      return 'fuel-normal';
    },
    bootTooltip(fuel: number, ammo: number, e: MouseEvent) {
      this.tooltipTimer = window.setTimeout(() => {
        this.tooltipX = e.clientX;
        this.tooltipY = e.clientY;
        this.enabledTooltip = true;

        this.fuelCorr = fuel < 75 ? `Evasion -${75 - fuel}` : 'None';
        this.ammoCorr = ammo < 50 ? `Damage x${(ammo * 2) / 100}` : 'None';
      }, 400);
    },
    clearTooltip() {
      this.enabledTooltip = false;
      window.clearTimeout(this.tooltipTimer);
    },
  },
});
